// Test IDs for the INDRIL landing / homepage hero experience.
// Keys camelCase, values kebab-case `<feature>-<element>`.

export const HOME = {
        emergentLink: 'home-emergent-link',
        // Navbar
        navbar: 'landing-navbar',
        navLogo: 'nav-logo',
        navGetApp: 'nav-get-app-btn',
        // Preloader
        preloader: 'intro-preloader',
        // Hero
        hero: 'hero-section',
        heroLogo: 'hero-logo',
        heroHeadline: 'hero-headline',
        ctaAppStore: 'cta-app-store',
        ctaGooglePlay: 'cta-google-play',
        ctaComingSoon: 'cta-coming-soon',
        // Badges
        trustedBadges: 'trusted-badges',
        // Features
        features: 'features-section',
        featureCard: 'feature-card',
        // Stats
        stats: 'stats-section',
        statItem: 'stat-item',
        // Manifesto
        manifesto: 'manifesto-section',
        // Marquee
        marquee: 'marquee-section',
        // Footer
        footer: 'landing-footer',
};
